// GOOWEBSS BOOK — the real application is a static, offline-first vanilla JS
// app served from frontend/public/ (entry gate: index.html, customer app: app/,
// admin panel: admin/). The React scaffold in src/ is unused placeholder code.
// This component intentionally renders nothing so it does not interfere with
// the static entry gate served from frontend/public/.
function App() {
  return null;
}

export default App;
